module.exports = __webpack_public_path__ + "static/media/gl.9e3c5924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gl.png
// module id = 1862
// module chunks = 0